































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';

import bImg from 'bootstrap-vue/es/components/image/img';

import {
  Image,
  ImageTag,
} from '@/models';

const ImageListViewProps = Vue.extend({
  props: {
    images: {
      type: Array as () => Image[],
      required: true,
    },
    previewImage: {
      type: Image,
    },
  },
});

@Component({
  components: {
    bImg,
  },
})
export default class ImageListView extends ImageListViewProps {
  public loadedImages: { [key: string]: Image; } = {};

  private focusedThumbnail: Image | null = null;
  private focusedImage: Image | null = null;

  public created() {
    this.onImagesChanged();
  }

  @Watch('images')
  public onImagesChanged() {
    // Show the first image.
    if (this.images && this.images.length > 0) {
      this.selectThumbnail(this.images[0]);
    }
  }

  @Watch('previewImage')
  public onPreviewImageChanged() {
    if (!this.previewImage) {
      this.selectThumbnail(this.focusedThumbnail!);
    } else {
      this.showImage(this.previewImage);
    }
  }

  public thumbnailClassObj(image: Image) {
    return [
      'thumbnail-image',
      'rounded',
      (image === this.focusedThumbnail) ? 'focus' : '',
    ];
  }

  public imageCanvasClassObj(image: Image) {
    return [
      'image-canvas',
      (image === this.focusedImage) ? 'focus' : '',
    ];
  }

  public selectThumbnail(thumbnail: Image) {
    // Focus the thumbnail.
    this.focusedThumbnail = thumbnail;
    // Show the image indicated by the thumbnail in canvas.
    this.showImage(thumbnail);
  }

  public showImage(image: Image) {
    // Load image.
    this.loadedImages[image.id] = image;
    // Show the image.
    this.focusedImage = image;
  }
}

